import Dashboard from "views/Dashboard";
import Login from "views/Login"
import Top from "views/Top";

export default [
    {
        collapse: true,
        path: "/login",
        exact: false,
        name: "ログイン",
        component: Login
    },
    {
        collapse: true,
        path: "/project/:name",
        exact: false,
        name: "プロジェクト",
        component: Dashboard
    },
    {
        collapse: true,
        path: "/",
        exact: true,
        name: "トップ",
        component: Top
    },
]
